import { useTranslation } from 'react-i18next';
import { Separator } from '@/Domain/components/Shared/Separator/Separator';
import { Skeleton } from '@/Domain/components/Shared/Skeleton/Skeleton';

type Props = {
  index: number;
  withIndex?: boolean;
};

export const ParagraphListItemSkeleton = ({ index, withIndex = true }: Props) => {
  const { t } = useTranslation('paragraphs');

  return (
    <div>
      <section
        className={` grid grid-cols-[0.15fr_1fr_0.01fr]  px-4 py-5 items-center opacity-${(index + 1) * 10}`}
      >
        <p className="text-sm text-foreground-subtle whitespace-nowrap ">
          {t('modal.list.item', { count: withIndex ? index + 1 : '' })}
        </p>
        <Skeleton className="h-[34px] w-full rounded-md my-1" />
        <div className="w-min text-right flex gap-2 justify-self-end">
          <Skeleton className="h-[34px] w-8 rounded-md" />
        </div>
      </section>
      <Separator />
    </div>
  );
};
